/*
 * Поповер для комментариев в таблице
 * Наследуется от Marionette.LayoutView
 * author Aleksander Vasilenko <info@acset.ru>
 * @2015
 */

define(function(require){
    'use strict';

    var Marionette  = require('marionette');
    var BasePopover = require('popovers/_base/view');
    var HeaderTPL   = require('text!popovers/sms_edit/header.tpl').default;
    var BodyTPL     = require('text!popovers/sms_edit/body.tpl').default;
    var FooterTPL   = require('text!popovers/sms_edit/footer.tpl').default;
    var Model       = require('models/sms');
    var Config      = require('config/application');
    var Backbone    = require('backbone');
    var TemplatesCollection 	= require('collections/messageTemplates');
    var TemplatesModel 	= require('models/messageTemplate');

    var HeaderView    = Marionette.ItemView.extend({
        template    : HeaderTPL,
        className   : 'b-popover__sms_edit-header',

        initialize : function (options){
            this.model = options.state;
        },

        onRender: function() {
            app.Rivets.bind(this.el, {model: this.model});
        }
    });

    var StateModel = Backbone.Model.extend({
        defaults: {
            count: 0,
            messages: 1,
            text: '0 символов - 1 SMS'
        }
    });

    var BodyView    = Marionette.ItemView.extend({
        template    : BodyTPL,
        className   : 'b-popover__sms_edit-body',

        ui: {
            textarea       : '.b-popover__sms_edit-text',
            templateSelect : '.js-sms-template',
            addTemplateBtn : '.js-add-tpl',
        },

        events: {
            'change @ui.templateSelect' : 'onSelectTemplate',
            'click @ui.addTemplateBtn'  : 'onClickAddTemplate',
        },

        initialize : function (options){
            this.state = options.state;
            this.sms = options.sms;
            this.templates = options.templates;
            this.listenTo(this.sms, 'change:text', this.onChangeText)
        },

        onChangeText: function(model, value) {
            var count = value.length;
            var messages = 0;

            if (value.length > 0) {
                if (value.length <= 70) {
                    messages = 1;
                } else {
                    messages = Math.floor((value.length / 67) + 1)
                }
            }

            this.state.set({
                count: count,
                messages: messages,
                text: count + ' ' + window.plural(count, ['символ', 'символа', 'символов']) + ' - ' + messages + ' SMS'
            })
        },

        onSelectTemplate: function() {
            var templateId = this.ui.templateSelect.val();
            var template = templateId && this.templates.get(templateId);

            if (template) {
                this.sms.set({
                    text: template.get('template_text'),
                    template_id: templateId
                });
            }
        },

        serializeData: function() {
            var templates = [];

            this.templates.each(function(template) {
                var obj = template.toJSON();

                obj.cid = template.cid;
                templates.push(obj);
            });
            return {
                templates: templates
            }
        },

        onRender : function (){
            //this.$el.lptSetter();
            this.ui.textarea.scrollbar();

            Backbone.Validation.bind(this, {
                model : this.sms
            });
            app.Rivets.bind(this.el, {model:this.sms});
            this.createSelect();
        },

        createSelect: function() {
            var that = this;
            var templateId = this.sms.get('template_id');
            
            this.ui.templateSelect.select2({
                dropdownParent: that.$el,
                allowClear: true,
                placeholder: {
                    id: '',
                    text:"Название шаблона",
                    selected:'selected'
                },
                escapeMarkup: function(markup) {
                    return markup;
                },
                language: {
                    noResults: function () {
                        var query = that.$('.select2-search__field').val();

                        return '<a href="javascript:void(0);" class="js-add-tpl">' + query + ' (создать новый шаблон)</a>';
                    }
                },
                templateResult: function(state) {
                    if (!state.id && !state.value){
                        return state.text;
                    }
                    var html = '<span>';
                        html += state.text;
                        html += '<i style="float:right" class="js-delete-template fa fa-times" data-id="' + state.id + '"></i>';
                    html += '</span>';
                    var $state = $(html);
                    return $state;
                }
            });
            this.ui.templateSelect.off('select2:selecting');
            this.ui.templateSelect.on('select2:selecting', function(event) {
                    var args = event.params.args;
                    var id;
                    if ($(args.originalEvent.target).hasClass('js-delete-template')) {
                        var cid = $(args.originalEvent.target).data('id');
                        that.deleteTemplate(cid);
                        return false;
                    }
                });
            if (templateId) {
                this.ui.templateSelect.val(templateId).trigger('change');
            }
        },

        deleteTemplate: function(cid)
        {
            var that = this;
            var template = this.templates.get(cid);
            var templateId = template.get('id');
            if(templateId){
                Backbone.ajax({
                    url: Config.host + '/rest/templates/' + templateId,
                    dataType: 'JSON',
                    type: 'DELETE',
                    success: function (response) {
                        app.message.success('Шаблон удален');
                        that.templates.remove(cid);
                        that.render();
                    },
                    error: function (xhr) {
                        app.message.success('Ошибка удаления шаблона');
                    }
                });
            }else{
                that.templates.remove(cid);
                that.render();
            }
        },

        onClickAddTemplate: function() {
            var name = this.$('.select2-search__field').val();
            var model = new TemplatesModel({
                template_name: name,
                template_text: this.sms.get('text'),
                type: 2,
            });

            this.templates.add(model);
            this.sms.set('template_id', model.cid);
            this.render();
        },

        onDestroy : function (){

        }
    });

    var FooterView  = Marionette.ItemView.extend({
        template    : FooterTPL,
        className   : 'b-popover__sms_edit-footer',

        initialize : function (options){
            this.lead_id = options.lead_id;
            this.state = options.state;
        },

        onRender: function(){
            app.Rivets.bind(this.el, {state: this.state});
        }
    });


    return BasePopover.extend({
        newEvents: {
            'click .js-column': 'toggleColumn'
        },

        ui: {
            addBtn         : '.js-add',
            saveTemplateBtn: '.js-save-template'
        },

        events: {
            'click @ui.addBtn': 'messageEdited',
            'click @ui.saveTemplateBtn': 'saveTemplate'
        },

        initialize: function(options) {
            BasePopover.prototype.initialize.call(this, options);
            this.state = new StateModel();
            this.sms = new Model();
            this.templates = new TemplatesCollection();
            this.templates
                .fetch({data:{siteId:app.curProject.id, type: 2}})
                .then(function(response) {
                    this.showBody();
                }.bind(this));
            this.listenTo(this.sms, 'change:template_id', this.onChangeTemplateId);
            this.listenTo(this.sms, 'change:text', this.onChangeText)
            this.getCurrentSender();
        },

        getCurrentSender: function() {
            Backbone.ajax({
                url: Config.host + '/rest/alfa/current_name',
                type: 'GET'
            })
            .then(function(data) {
                if (data) {
                    this.state.set('senderName', data.alfa_name);
                }
            }.bind(this))
        },

        onBeforeRender : function(){
            var self = this;
            var options = {
                popover_id  : 'b-popover__sms_edit',
                title       : '',
                width       : 600,
                show_header : false,
                show_footer : true
            };

            this.model.set(options);
            this.leadId = this.model.get('popoverData').id;
        } ,

        showHeader: function() {
            this.regionHeader.show(new HeaderView({state: this.state}));
        },

        showBody: function(){
            this.regionBody.show(new BodyView({sms : this.sms, state: this.state, templates: this.templates}));
        },

        showFooter: function(){
            this.regionFooter.show(new FooterView({ state: this.state }));
        },

        messageEdited: function() {
            var text = this.sms.get('text') || '';
            var templateId = this.sms.get('template_id');
            var template = this.templates.get(templateId);

            if(text.length) {
                if (template && template.isNew()) {
                    this.saveTemplate()
                        .then(function() {
                            this.hide();
                            this.trigger('sms:edited', this.sms.get('text'));
                        }.bind(this));
                } else {
                    this.hide();
                    this.trigger('sms:edited', this.sms.get('text'));
                }
            } else {
                app.message.error('Введите текст сообщения');
            }
        },

        saveTemplate: function() {
            var def = new $.Deferred();
            var templateId = this.sms.get('template_id');
            var template = this.templates.get(templateId);

            var templateText = this.sms.get('text');
            var templateName = '';
            if(template){
                templateName = template.get('template_name');
            }

            if(templateName.length > 0){
                if(templateText.length > 0){
                    template.set({
                        template_text: this.sms.get('text'),
                    });
                    template
                        .save()
                        .then(function () {
                            app.message.success('Шаблон сохранен');
                            def.resolve();
                        }.bind(this))
                        .fail(function (xhr) {
                            var message = xhr.responseJSON && xhr.responseJSON.message || 'Не удалось сохранить шаблон';
                            app.message.error(message);
                        })
                }else{
                    app.message.error('Введите текст сообщения');
                    $('.js-sms-text-wrapper').addClass('border-red');
                    setTimeout(function(){
                        $('.js-sms-text-wrapper').removeClass('border-red');
                    }, 2000);
                }
            }else{
                app.message.error('Введите название шаблона');
                $('.js-sms-template-wrapper').addClass('border-red');
                setTimeout(function(){
                    $('.js-sms-template-wrapper').removeClass('border-red');
                }, 2000);
            }

            return def;
        },

        onChangeTemplateId: function(model, value) {
            var template = value && this.templates.get(value);

            if (template) {
                if (template.isNew()) {
                    this.$('.js-add').text('Отправить SMS и сохранить шаблон');
                } else {
                    this.$('.js-add').text('Отправить SMS');
                }
            }
            if (value) {
                this.toggleAddTemplateBtn(this.templates.get(value).isNew());
            }
        },

        onChangeText: function() {
            if (this.sms.get('template_id')) {
                this.toggleAddTemplateBtn(true);
            }
        },

        toggleAddTemplateBtn: function(value) {

        },
    });

 });
